export const GET_FILE_DATA_REQUEST = "GET_FILE_DATA_REQUEST";
export const GET_FILE_DATA_SUCCESS = "GET_FILE_DATA_SUCCESS";
export const GET_FILE_DATA_FAIL = "GET_FILE_DATA_FAIL";
export const GET_FILE_DATA_RESET = "GET_FILE_DATA_RESET";